import {BaseColumn, BaseColumnConfig} from './base-column.model';

export interface Icon {
  case: any;
  icon: string;
}

export class IconColumn extends BaseColumn {
  icons: Icon[];

  constructor(title: string,
              config: IconColumnConfig) {
    super(title,
      {
        property: config.property,
      });
    this._columnType = 'IconColumn';
    this.icons = config.icons;
  }

  get(element: any): any {
    return this.icons.find(icon => icon.case === element[this.property]).icon;
  }
}

export interface IconColumnConfig extends BaseColumnConfig {
  icons: Icon[];
}
